export default __webpack_public_path__ + "static/media/cemair-logo.06edb777.png";